(() => {
  const initBigDiscount = (root) => {
    if (root.dataset.goodlotBigDiscountInitialized === 'true') return;

    const viewport = root.querySelector('[data-goodlot-big-discount-viewport]');
    const track = root.querySelector('[data-goodlot-big-discount-track]');
    const dots = [...root.querySelectorAll('[data-goodlot-big-discount-dot]')];
    if (!viewport || !track || dots.length === 0) return;

    root.dataset.goodlotBigDiscountInitialized = 'true';
    const cards = [...track.children];

    const getCardScrollLeft = (card) => {
      const viewportRect = viewport.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const rawPosition = cardRect.left - viewportRect.left + viewport.scrollLeft;
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      return Math.min(Math.max(0, rawPosition), maxScroll);
    };

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const card = cards[index];
        if (!card) return;
        viewport.scrollTo({ left: getCardScrollLeft(card), behavior: 'smooth' });
        setActive(index);
      });
    });

    let scrollFrame;
    viewport.addEventListener('scroll', () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        if (cards.length === 0) return;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;
        cards.forEach((card, index) => {
          const distance = Math.abs(getCardScrollLeft(card) - viewport.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        setActive(Math.min(closestIndex, dots.length - 1));
      });
    }, { passive: true });
  };

  const init = () => {
    document.querySelectorAll('[data-goodlot-big-discount]').forEach(initBigDiscount);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('[data-goodlot-big-discount]');
    if (root) initBigDiscount(root);
  });
})();
